export const REFERRAL_STORAGE_KEY = 'maarivil_ref_code';

export const readStoredReferral = () => {
  try {
    const v = localStorage.getItem(REFERRAL_STORAGE_KEY);
    return v ? v.toString().toLowerCase().replace(/[^a-z0-9]/g, '') : '';
  } catch (_e) {
    return '';
  }
};

export const clearStoredReferral = () => {
  try { localStorage.removeItem(REFERRAL_STORAGE_KEY); } catch (_e) { /* ignore */ }
};

export const storeReferral = (code) => {
  const clean = (code || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!clean) return '';
  try { localStorage.setItem(REFERRAL_STORAGE_KEY, clean); } catch (_e) { /* ignore */ }
  return clean;
};
